export default __webpack_public_path__ + "b9953fd2a02369404ac08d87f3baa126.png";